<div class="navigation-inner default-max-width centered">
  <div class="flex navigation-items flex--jc-space-between">
    <app-catalog-menu class="catalog-menu"></app-catalog-menu>
    <app-cms-menu class="cms-menu"></app-cms-menu>
  </div>
</div>
